import React, { useState } from "react";
import OnboardingLayout from "./OnboardingLayout";
import { Grid } from "@chakra-ui/react";
import OnboardingCard from "../Cards/OnboardingCard";
import { LanguageLearningChallenge } from "@shared_types";

interface ChallengesProps {
  setChallenge: (challenge: string, code: LanguageLearningChallenge) => void;
}

type Challenge = {
  emoji: string;
  text: string;
  subtitle: string;
  code: LanguageLearningChallenge;
};

const Challenges: React.FC<ChallengesProps> = ({ setChallenge }) => {
  const [selectedChallenge, setSelectedChallenge] = useState<string | null>(
    null
  );
  const challenges: Challenge[] = [
    {
      emoji: "⏰",
      text: "No time",
      subtitle: "I don't have time to study",
      code: "no_time",
    },
    {
      emoji: "🤷",
      text: "Where to start",
      subtitle: "I don't know where to start",
      code: "where_to_start",
    },
    {
      emoji: "💪",
      text: "Staying motivated",
      subtitle: "I struggle to stay motivated",
      code: "staying_motivated",
    },
    {
      emoji: "😵‍💫",
      text: "Grammar issues",
      subtitle: "I have trouble with grammar",
      code: "grammar_issues",
    },
    {
      emoji: "🗣️",
      text: "Speaking practice",
      subtitle: "I want to practice speaking",
      code: "speaking_practice",
    },
    {
      emoji: "📚",
      text: "Vocabulary overload",
      subtitle: "I have trouble with vocabulary",
      code: "vocabulary_overload",
    },
  ];

  return (
    <OnboardingLayout
      title="What are your challenges with language learning?"
      subtitle="We're here to help you overcome them."
    >
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={4}
        maxW="600px"
        margin="0 auto"
      >
        {challenges.map((challenge, index) => (
          <OnboardingCard
            key={index}
            emoji={challenge.emoji}
            title={challenge.text}
            disabled={false}
            learnerCount={""}
            selected={selectedChallenge === challenge.text}
            onClick={() => {
              setChallenge(challenge.text, challenge.code);
              setSelectedChallenge(challenge.text);
            }}
          />
        ))}
      </Grid>
    </OnboardingLayout>
  );
};

export default Challenges;
